import { render } from "./AExpansionPanelText.vue?vue&type=template&id=20278970"
import script from "./AExpansionPanelText.vue?vue&type=script&lang=js"
export * from "./AExpansionPanelText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__